import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Layout, Menu, MenuProps } from 'antd';
import Paths, { Path } from 'routes';
import SubMenu from 'antd/lib/menu/SubMenu';
import { PurpleLogo, UserInfo } from 'components/molecules';
import useStore from 'store';

export interface HeaderProps {}

const Header = (props: HeaderProps): React.ReactElement => {
  /* ======================================================
   * stores
   * ====================================================== */
  const auth = useStore((state) => state.auth);  

  /* ======================================================
   * variables
   * ====================================================== */
  const { paths } = Paths;

  /* ======================================================
   * states
   * ====================================================== */
  const [selected, setSelected] = useState('');

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const splitPath = location.pathname.split('/');
    if (splitPath.length > 3) setSelected(`${splitPath[1]}/${splitPath[2]}/${splitPath[3]}`);
    else if (splitPath.length > 2) setSelected(`${splitPath[1]}/${splitPath[2]}`);
    else if (splitPath[0] === 'mypage') setSelected('/');
    else setSelected(splitPath[1] || '/');

  }, [location.pathname]);

  /* ======================================================
   * events
   * ====================================================== */
  const onClick: MenuProps['onClick'] = (e) => {
    setSelected(e.key);
  };

  /* ======================================================
   * render items
   * ====================================================== */
  const makeMenu = (paths: Path[]) => {
    return paths.map((p) => {
      if (!p.isShow) return;
      if (!!p.rule && auth.login && auth.login.div && !p.rule.includes(auth.login.div)) return;

      if (p.children) {
        return (
          <SubMenu key={p.key} title={p.title}>
            {makeMenu(p.children)}
          </SubMenu>
        );
      } else {
        return (
          <Menu.Item key={p.key}>
            <NavLink to={p.key}>{p.title}</NavLink>
          </Menu.Item>
        );
      }
    });
  };
  const MenuItems = makeMenu(paths);
  return (
    <Layout.Header className="header-container">
      <div className="header">
        <PurpleLogo />
        <Menu 
          style={{position: 'relative', display: 'flex', justifyContent: 'center' }} 
          theme="light" 
          selectedKeys={[selected]} 
          mode="horizontal" 
          onClick={onClick}>
          {MenuItems}
        </Menu>
        <UserInfo />
      </div>
    </Layout.Header>
  );
};

export default Header;
